<style lang="less">
.search {
  width: 100%;
  height: 100%;
}
</style>
<template>
  <div class="positionItem" @click="goDetail(row.id)">
    <h3>
      <label>{{ row.name }}</label>
      <span>New</span>
    </h3>
    <div class="info">
      <span>{{ row.city }}</span>
      <span>|</span>
      <span>{{ row.category }}</span>
      <span>|</span>
      <span>{{ enumType[row.positionType] }}</span>
    </div>
  </div>
</template>
<script>
import positionType from "@/enum/positionType"
export default {
  props: {
    row: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  data(){
    return {
      enumType: positionType
    }
  },
  methods: {
    goDetail(id) {
      if (id) {
        this.$router.push({
          path: `/join/detail/${id}`
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.positionItem {
  padding: 32px 40px;
  background: #ffffff;
  box-sizing: border-box;
  margin-bottom: 20px;
  transition-duration: 0.3s;
  border: 1px solid #fff;
  cursor: pointer;

  h3 {
    display: flex;
    align-items: baseline;
    margin-bottom: 15px;
    label {
      font-size: 20px;
      color: #242A32;
      margin-right: 10px;
      font-weight: bold;
    }
    span {
      color: #FF4D00;
      font-size: 12px;
    }
  }

  .info {
    span {
      margin-right: 10px;
      font-size: 16px;
      color: #5E656C;
    }
  }

  &:hover {
    border: 1px solid #2284F6;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/join/Item.vue